module.exports = __webpack_public_path__ + "img/logo.1da3aa0d.png";